<template>
  <v-dialog persistent v-model="closeTicketDialog" max-width="600">
    <v-card class="pa-3">
      <v-card-title class="headline pl-0 pt-0">
        Close Ticket
      </v-card-title>
      <v-form>
        <v-card-text class="font-weight-bold">
          Please let us know why you are closing this ticket.
          <br />
          You can select an option or enter your own (optional).
        </v-card-text>
        <v-radio-group v-model="closeReasonSelect">
          <v-radio
            class="font-weight-bold"
            v-for="n in closeReasons()"
            :key="n"
            :label="`${n}`"
            :value="n"
          ></v-radio>
        </v-radio-group>
        <v-flex xs8>
          <v-Textarea
            v-model="closeReasonMessage"
            label="why you are closing this ticket? (optional)."
            outline
            ref="addConversation"
          ></v-Textarea>
        </v-flex>
        <v-card-text style="font-size: 13px;">
          Your input is not tracked; we only use it to help improve future
          problem-solving.
        </v-card-text>
      </v-form>

      <v-card-actions class="mr-0 mt-3 pb-0">
        <v-spacer></v-spacer>
        <v-btn color="default" dark @click="resetCloseTicketDialog()">
          cancel
        </v-btn>
        <v-btn
          :loading="processing"
          color="success"
          dark
          @click="closeTicket()"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  async created() {
    this.request = this.initialData.request
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.closeTicketDialog = val;
      },
    },
    closeTicketDialog(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    closeTicketDialog: false,
    closeReasonSelect: "",
    closeReasonMessage: "",
    request: "",
    processing: false,
  }),
  methods: {
    closeReasons() {
      const list = [
        "Issue resolved independently",
        "Issue no longer relevant",
        "Internal decision",
      ];
      return list;
    },
    resetCloseTicketDialog() {
      this.closeTicketDialog = false;
      this.closeReasonSelect = null;
      this.closeReasonMessage = null;
    },
    async closeTicket() {
      const closeReason =
        this.closeReasonSelect || this.closeReasonMessage
          ? `<b>The ticket was closed by ${
              this.$store.state.authentication.user
            } <br> on user portal provid resolution/reason: </b> ` +
            (this.closeReasonSelect ? this.closeReasonSelect + ", " : "") +
            " " +
            (this.closeReasonMessage ? this.closeReasonMessage : "")
          : `The ticket was closed by ${
              this.$store.state.authentication.user
            } on user portal without providing a resolution/reason`;
      try {
        this.processing = true;
        await this.$http.put("api/manageengine/CloseTicket", {
          Acknowledge: "Ignored",
          Resolution: closeReason,
          Technician: this.request.technicianName,
          ManageengineID: this.request.manageengineID,
          Category: this.request.categoryName,
        });

       this.$emit("tickedClosed");

        this.conversationList = null;
        this.loadAllConversationsBtn = false;
        this.$notify({
          group: "notification",
          text: "Ticked Closed",
          type: "success",
        });
        this.resetCloseTicketDialog();
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
  },
};
</script>
